import React from 'react';
import { MapPin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  return <header className="w-full bg-black border-b border-[#2A2A2A] sticky top-0 z-50" data-id="element-271" data-mp="2dn5uypywytkf">
      <div className="max-w-[1600px] mx-auto px-4 md:px-6 h-20 flex items-center justify-between" data-id="element-272" data-mp="2ikfq8m8zhzg6">
        {/* Logo */}
        <Link to="/" className="cursor-pointer flex-shrink-0" data-id="element-273" data-mp="2nm54eari6t8h">
          <img src="https://cdn.magicpatterns.com/uploads/eyDhwupaqmpcRwhonPYhLR/LUSSO_GROUP_LOGO.png" alt="Lusso Group" className="h-52 md:h-[336px] w-auto object-contain brightness-0 invert" data-id="element-274" data-mp="2rmxet7c4346c" />
        </Link>

        {/* Actions */}
        <div className="flex items-center gap-4 md:gap-6" data-id="element-275" data-mp="36as9gt9ojim2">
          {/* Instagram */}
          <a href="https://www.instagram.com/lussogroup.ba/" target="_blank" rel="noopener noreferrer" aria-label="Ver Instagram de Lusso Group" className="p-3 rounded-xl bg-[#1C1C1C] hover:bg-[#333333] transition-colors duration-200 shadow-md" data-id="element-276" data-mp="3ba4ur9kwkhmj">
            <Instagram className="w-8 h-8 text-white" strokeWidth={1.8} data-id="element-277" data-mp="2rl8b4q2nyd04" />
          </a>

          {/* Google Maps */}
          <a href="https://maps.app.goo.gl/X7PnVEoo9oLiE8h29" target="_blank" rel="noopener noreferrer" aria-label="Ver ubicación en Google Maps" className="p-3 rounded-xl bg-[#1C1C1C] hover:bg-[#333333] transition-colors duration-200 shadow-md" data-id="element-278" data-mp="2mlvghj5jw1mz">
            <MapPin className="w-8 h-8 text-white" strokeWidth={1.8} data-id="element-279" data-mp="3adkdvdx8bgas" />
          </a>
        </div>
      </div>
    </header>;
}